import type { FC, MouseEvent, ReactNode } from 'react'
import type { PathChoice } from '@/types'
import type { SmartLinkProps } from '@/components/generals/smart-link'

import { choosePath } from '@/lib/quote'
import SmartLink from '@/components/generals/smart-link'

interface QuoteLinkProps extends Omit<SmartLinkProps, 'href'> {
    path?: PathChoice
}

// Sends the visitor to the contact form and, when a path is given, preselects it there.
const QuoteLink: FC<QuoteLinkProps> = ({ path, onClick, children, ...rest }): ReactNode => {
    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        if (path) choosePath(path)

        onClick?.(event)
    }

    return (
        <SmartLink href='/#contact' onClick={handleClick} {...rest}>
            {children}
        </SmartLink>
    )
}

export default QuoteLink
